import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMAGE, PRODUCT_NAME } from '../data/constants';
const INCLUDES = ['Learn the complete process from scratch', 'Create soft, consistent cinnamon rolls', 'Master fillings and flavor variations', 'Shape and bake with greater consistency', 'Create professional frostings and finishes', 'Prepare a product you can confidently offer for sale'];
export function SystemSection() {
  return <section className="border-y-4 border-gold bg-espresso px-4 py-6 text-cream" data-id="element-214" data-mp="2wsxtrdc9kr2i">
      <div className="mx-auto max-w-4xl text-center" data-id="element-215" data-mp="2srvtquaiwazh">
        <h2 className="text-xl sm:text-3xl" data-id="element-216" data-mp="2sqax8z4nehyz">The Complete System You&apos;ve Been Looking For</h2>
        <p className="mt-1 text-xs font-extrabold uppercase tracking-widest text-gold sm:text-sm" data-id="element-217" data-mp="2nv5a5wziex9b">
          One Complete 6-in-1 Cinnamon Roll System
        </p>
        <div className="mt-3 grid items-center gap-4 md:grid-cols-2" data-id="element-218" data-mp="2dw62agmkj5nd">
          <a href={OFFER_ANCHOR} className="block focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60" data-id="element-219" data-mp="13zhqn5wtd9zu">
            <img src={PRODUCT_IMAGE} alt={`${PRODUCT_NAME} — the ultimate business bundle`} className="mx-auto w-full max-w-xs drop-shadow-2xl md:max-w-full" data-id="element-220" data-mp="18q6fedh3zsva" />
          </a>
          <div className="text-left" data-id="element-221" data-mp="z0mwj7tebz0f">
            <h3 className="text-lg text-gold sm:text-2xl" data-id="element-222" data-mp="1mppnx7du1684">🍥 {PRODUCT_NAME}</h3>
            <p className="text-sm font-extrabold uppercase tracking-wide text-cream sm:text-base" data-id="element-223" data-mp="1mnmo5vmvnyq7">
              The Ultimate Business Bundle
            </p>
            <p className="mt-1 text-sm font-semibold text-cream/85" data-id="element-224" data-mp="1cqi0frddvv7a">
              The Complete Step-by-Step System to Create Professional Cinnamon Rolls You Can Sell
            </p>
            <div className="mt-2 space-y-0.5 text-sm font-semibold text-cream/70" data-id="element-225" data-mp="1buzu0mlj53i">
              <p data-id="element-226" data-mp="6b7moldgwc63">Not a random recipe collection.</p>
              <p data-id="element-227" data-mp="6d0tc0o2ywe3">Not a basic baking ebook.</p>
              <p data-id="element-228" data-mp="28xv46ucnsbw7">Not endless theory.</p>
            </div>
            <p className="mt-2 text-sm font-bold text-cream" data-id="element-229" data-mp="28xl8qr8uhcj4">
              A complete practical system designed to help you go from “I want to start selling something” to “I know
              how to create my product.”
            </p>
            <ul className="mt-3 grid gap-1.5" data-id="element-230" data-mp="1u98d5vdo5vp5">
              {INCLUDES.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-cream/90" data-id="element-231" data-mp="1u7e0f4cjx9w5">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-232" data-mp="1l8jycyggbrb7" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-4" data-id="element-233" data-mp="1gbacttw6nzsn">
              <CTAButton href={OFFER_ANCHOR} data-id="element-234" data-mp="1bb5urzfmmx0b">🍥 YES! I WANT TO START NOW</CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}